import styled from 'styled-components';

import { FlexWithAlign } from '../../../../../utils/styleUtils';

export const ModalWrapper = styled(FlexWithAlign)``;
